import { api } from '@mmef/shared/api';
import type { Subscription, SubscriptionInput } from '@mmef/shared/api';

export const subscriptionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    listSubscriptions: build.query<Subscription[], void>({
      query: () => '/me/subscriptions',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Subscriptions' as const, id })),
              { type: 'Subscriptions' as const, id: 'LIST' },
            ]
          : [{ type: 'Subscriptions' as const, id: 'LIST' }],
    }),

    createSubscription: build.mutation<Subscription, SubscriptionInput>({
      query: (body) => ({ url: '/me/subscriptions', method: 'POST', body }),
      invalidatesTags: [{ type: 'Subscriptions', id: 'LIST' }],
    }),

    updateSubscription: build.mutation<Subscription, { id: number; body: SubscriptionInput }>({
      query: ({ id, body }) => ({ url: `/me/subscriptions/${id}`, method: 'PUT', body }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Subscriptions', id },
        { type: 'Subscriptions', id: 'LIST' },
      ],
    }),

    deleteSubscription: build.mutation<void, number>({
      query: (id) => ({ url: `/me/subscriptions/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Subscriptions', id: 'LIST' }],
    }),
  }),
});

export const {
  useListSubscriptionsQuery,
  useCreateSubscriptionMutation,
  useUpdateSubscriptionMutation,
  useDeleteSubscriptionMutation,
} = subscriptionsApi;
